
function TodoList(props){
    return(
       <ul className="taskApp__list">
        {props.children}
       </ul>
    );
}

export {TodoList};